import jwt_decode, { JwtPayload } from "jwt-decode";

export const isExpiredToken = (token: string) => {
    let decodedToken: any = jwt_decode<JwtPayload>(token);
    let tokenExpiry = new Date(decodedToken.exp * 1000)
    let now = new Date()
    return tokenExpiry.getTime() - now.getTime() < 5 * 60 * 1000
}